/* eslint-disable react/require-default-props */
import { MultilineTextField } from '@/components/CustomInput';
import { Typography } from '@mui/material';
import { useState } from 'react';

import {
  DialogTitle,
  WhiteCircularProgress,
} from '../../../../components/UI/Typography';
import { Constants } from '../../../../constants/finance';
import {
  IconCancelMS,
  IconCurrencyExchangeCopyMS,
} from '../../../../constants/icons';
import {
  ChargeBackButton,
  DialogContainer,
  StyledDialog,
  OutlinedButton,
  FilledButton,
  ButtonBox,
  ConfirmationContainer,
} from './styles';

export interface CancelDialogProps {
  isRefund?: boolean;
  loading: boolean;
  reason: string;
  setReason: (value: string) => void;
  onSubmit: () => Promise<void>;
}

export default function CancelDialog({
  isRefund = false,
  loading,
  reason,
  setReason,
  onSubmit,
}: CancelDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  const mainColor = isRefund ? '#FB923C' : '#FF334B';

  const handleOpen = async (): Promise<void> => {
    setConfirmAction(false);
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
    setReason('');
  };

  const handleSubmit = (): void => {
    onSubmit();
    handleClose();
  };

  const handleConfirm = (): void => setConfirmAction(true);

  return (
    <>
      <ChargeBackButton
        disabled={loading}
        onClick={handleOpen}
        sx={{
          color: isRefund ? '#fff' : '#FF334B',
          border: isRefund ? 'transparent' : '1px solid #FF334B',
          borderColor: isRefund ? 'transparent ' : '#FF334B',
          backgroundColor: isRefund ? '#FB923C' : 'transparent',
          '&:hover': {
            backgroundColor: mainColor,
          },
        }}
      >
        {loading ? (
          <WhiteCircularProgress size={22} />
        ) : (
          <>
            {isRefund ? IconCurrencyExchangeCopyMS : IconCancelMS}
            {isRefund ? Constants.refundPayment : Constants.cancelPayment}
          </>
        )}
      </ChargeBackButton>
      <StyledDialog open={open} onClose={handleClose}>
        {!confirmAction ? (
          <ConfirmationContainer>
            <Typography>
              {Constants.confirmAction.replace(
                '{{action_type}}',
                isRefund ? Constants.chargeback : Constants.cancellation
              )}
            </Typography>
            <ButtonBox>
              <OutlinedButton
                onClick={handleClose}
                sx={{
                  borderColor: mainColor,
                  color: mainColor,
                  '&:hover': {
                    backgroundColor: mainColor,
                  },
                }}
              >
                {Constants.cancel}
              </OutlinedButton>
              <FilledButton
                onClick={handleConfirm}
                sx={{
                  backgroundColor: mainColor,
                  '&:hover': {
                    backgroundColor: mainColor,
                  },
                }}
              >
                {Constants.confirm}
              </FilledButton>
            </ButtonBox>
          </ConfirmationContainer>
        ) : (
          <DialogContainer>
            <DialogTitle>{Constants.reason}</DialogTitle>
            <MultilineTextField
              id="charge-back-reason"
              label=""
              placeholder="Descreva..."
              value={reason}
              setValue={setReason}
              maxLength={500}
            />
            <ButtonBox>
              <OutlinedButton onClick={handleClose}>
                {Constants.cancel}
              </OutlinedButton>
              <FilledButton onClick={handleSubmit}>
                {Constants.confirm}
              </FilledButton>
            </ButtonBox>
          </DialogContainer>
        )}
      </StyledDialog>
    </>
  );
}
